import { useEffect, useRef } from "react";
import _ from "underscore";

import { useLazyGetAdhocQueryMetadataQuery } from "metabase/api";
import * as Lib from "metabase-lib";
import type Question from "metabase-lib/v1/Question";

/**
 * Load the metadata a question depends on, e.g. the cards behind
 * `{{#123-some-model}}` references.
 *
 * Only call this for the *active* tab: hydrating a workbench with many tabs
 * would otherwise fire one `/api/dataset/query_metadata` request per tab at
 * once, for metadata nothing is about to render.
 */
export function useTabQueryMetadata(question: Question, enabled = true): void {
  const [loadMetadata] = useLazyGetAdhocQueryMetadataQuery();
  const dependenciesRef = useRef<Lib.DependentItem[]>([]);

  useEffect(() => {
    if (!enabled) {
      return;
    }
    const dependencies = Lib.dependentMetadata(
      question.query(),
      undefined,
      question.type(),
    );
    if (!_.isEqual(dependencies, dependenciesRef.current)) {
      dependenciesRef.current = dependencies;
      loadMetadata(question.datasetQuery());
    }
  }, [enabled, loadMetadata, question]);
}
